import LangSelector from './components/lang-selector';
import SiteHeader from './components/site-header';
import NewsSlider from './components/news-slider';
import PartnersSlider from './components/partners-slider';
import KeyFiguresSlider from './components/key-figures-slider';
import BUProductSlider from './components/buproduct-slider';
import ImageHotspotsSelector from './components/image-hotspots-selector';
import HandheldMenu from "./components/handheld-menu";
import CookiesConsent from "./components/cookies-consent";
import DropdownMenu from "./components/dropdown-menu";
import Accordion from "./components/accordion";
import Maps from "./components/offices-map";
import LocationsMap from "./components/locations-map";
import JobOfferList from "./components/job-offer-list";
import Timeline from "./components/timeline";
import NewsletterForm from "./components/newsletter-form";
import ScrollInView from "./components/scroll-in-view";

import DeviceManager from './utils/device-manager';

(function($) {
    window.$ = $;
    const lang = typeof ver.lang !== 'undefined' ? ver.lang : 'en';

    $(function() {
        const $html = $('html');

        // Touch device detection
        if(DeviceManager.isHandheld()) {
            $html.addClass('touch');

            if(DeviceManager.isIos()) {
                $html.addClass('ios');
            }
        }
        else {
            $html.addClass('no-touch');
        }

        // IE detection
        if(DeviceManager.isIe11()) {
            $html.addClass('ie11');
        }
        else if(DeviceManager.isEdge()) {
            $html.addClass('edge');
        }

        // Handheld menu
        const handheldMenu = new HandheldMenu();

        // General components
        const langSelector = new LangSelector($('.language-selector'));
        const siteHeader = new SiteHeader($('.site-header'), 20);
        //const dropdownMenu = new DropdownMenu($('.header__nav'));

        // News slider component
        const $newsSliders = $('.news-slider');
        if($newsSliders.length) {
            $newsSliders.each(function(index, el) {
                const newsSlider = new NewsSlider($(el));
            });
        }

        // Partners slider component
        const $partnersSliders = $('.partners-slider');
        if($partnersSliders.length) {
            $partnersSliders.each(function(index, el) {
                const partnerSlider = new PartnersSlider($(el));
            });
        }

        // Key Figures slider component
        const $keyFiguresSlider = $('.key-figures-slider');
        if($keyFiguresSlider.length) {
            $keyFiguresSlider.each(function(index, el) {
                const keyFiguresSlider = new KeyFiguresSlider($(el));
            });
        }

        // BU Product slider component
        const $buProductSlider = $('.bu-products-slider');
        if($buProductSlider.length) {
            $buProductSlider.each(function(index, el) {
                const buProductSlider = new BUProductSlider($(el));
            });
        }

        // Image with hotspots component
        const $imagesWithHotspots = $('.image-hotspots-selector');
        if($imagesWithHotspots.length) {
            $imagesWithHotspots.each(function(index, el) {
                const imageWithHotspots = new ImageHotspotsSelector($(el));
            });
        }

        // Image with hotspots component
        const $jobOffersList = $('.archive-offers_list');
        const $jobOffersSearchForm = $('.archive-offers_searchform');
        const $jobOffersCountryFilter = $('.archive-offers_country-filter');
        if($jobOffersList.length && $jobOffersSearchForm.length && $jobOffersCountryFilter.length) {
            const jobOffersList = new JobOfferList($jobOffersList, $jobOffersSearchForm, $jobOffersCountryFilter);
        }

        // Locations map component
        const $locationsMapsElements = $('.location-map-placeholder');
        if($locationsMapsElements.length) {
            $locationsMapsElements.each(function(index, el) {
                const locationsMap = new LocationsMap(el);
            });
        }

        // Newsletter form component
        const $newsletterFormElements = $('.footer-block.footer-block--newsletter-style');
        if($newsletterFormElements.length) {
            $newsletterFormElements.each(function(index, el) {
                const newsletterForm = new NewsletterForm(el);
            });
        }

        // Timeline component
        const $timelineElements = $('.timeline');
        if($timelineElements.length) {
            $timelineElements.each(function(index, el) {
                const $el = $(el);

                // $el.imagesLoaded(function() {
                    const timeline = new Timeline($el);
                // });
            });
        }

        // Scroll in view component
        const $scrollInViewElements = $('.scroll-in-view');
        if($scrollInViewElements.length) {
            $scrollInViewElements.imagesLoaded(function() {
                const scrollInView = new ScrollInView($scrollInViewElements);
            });
        }

        // Cookie consent
        if(typeof tarteaucitron !== 'undefined' && tarteaucitron) {
            // Tarteaucitron cookie settings
            let tarteaucitronLang = lang || 'en';

            if(lang === 'cn') {
                tarteaucitronLang = 'en';
            }

            const cookiesConsent = new CookiesConsent(tarteaucitronLang);
        }

        $('.mediatheque-filters li.cat-has-children').on('mouseenter', function(e) {
            const $target = $(e.currentTarget);
            const $children = $target.find('> .children');

            if($children.length) {
                $('.mediatheque-filters').css('padding-bottom', $children.outerHeight());
            }
        });
        $('.mediatheque-filters li.cat-has-children').on('mouseleave', function(e) {
            $('.mediatheque-filters').css('padding-bottom', 0);
        });

        if(window.matchMedia("(max-width: 767px)").matches){

            $('.mediatheque-filters .cat-has-children > a').click(function() {
                event.preventDefault();

                var $this = $(this);
                var $catItem = $this.parent('.cat-has-children');

                $catItem.toggleClass('opened');
            });
        }

        $('.main-menu__toggle-submenu-arrow').on('click', (e) => {
            e.preventDefault();

            const target = e.currentTarget;
            target.parentNode.classList.toggle('menu-item--opened');
        });
    });


})(jQuery);
